import React from 'react';

import CallController from '../../controller/CallController';
import Const from '../../util/Constants';

import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';
import FieldNumber from '../common/FieldNumber';
import FieldDecimal from '../common/FieldDecimal';

class CallCustom extends React.Component {

  getCustomFields = (lead, fields, onValueChange, inValid) => {
    const customField = CallController.getCustomFields(fields);
    let list = [];
    let keys = Object.keys(customField);
    keys = keys.sort((field1, field2) => fields[field1].field_order - fields[field2].field_order);
    for(let i = 0; i < keys.length; i++) {
      const fieldOption = this.props.fieldOption;
      const type = customField[keys[i]].field_type;
      const key = keys[i];
      const field = customField[keys[i]];
      const value = lead[keys[i]];
      const innerData = { key: key, id: key, field: field, value: value,
        onValueChange: onValueChange, inValid: inValid, fieldOption };
      if(type === Const.Text) list.push(<FieldText {...innerData}/>);
      else if(type === Const.TextArea) list.push(<FieldTextArea {...innerData}/>);
      else if(type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect {...innerData}/>);
      else if(type.includes(Const.Select)) list.push(<FieldSelect { ...innerData } />);
      else if(type === Const.Date) list.push(<FieldDate { ...innerData } />);
      else if(type === Const.DateTime) list.push(<FieldDateTime { ...innerData } />);
      else if(type === Const.Toggle) list.push(<FieldToggle { ...innerData } />);
      else if(type === Const.Address) list.push(<FieldAddress { ...innerData } />);
      else if(type === Const.Decimal) list.push(<FieldDecimal {...innerData}/>);
      else if(type === Const.Number) list.push(<FieldNumber {...innerData}/>);
    }
    return list;
  }
  
  render() {
    const call = this.props.call;
    const fields = this.props.model.fields;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    const list = this.getCustomFields(call, fields, onValueChange, inValid);
    if(list.length === 0) return null;
    return <>{list}</>;
  }
}

export default CallCustom;